import React from 'react';

export const SidebarHomeIcon = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25 19.2498V12.4664C8.25 11.953 8.25 11.6964 8.34991 11.5003C8.4378 11.3278 8.57803 11.1876 8.75051 11.0997C8.94659 10.9998 9.20324 10.9998 9.71667 10.9998H12.2833C12.7968 10.9998 13.0534 10.9998 13.2495 11.0997C13.422 11.1876 13.5622 11.3278 13.6501 11.5003C13.75 11.6964 13.75 11.953 13.75 12.4664V19.2498M10.0996 2.53344L3.88244 7.36897C3.46685 7.69221 3.25906 7.85383 3.10936 8.05623C2.97676 8.23551 2.87797 8.43749 2.81786 8.65224C2.75 8.89467 2.75 9.15792 2.75 9.68445V16.3164C2.75 17.3432 2.75 17.8565 2.94982 18.2488C3.12559 18.5937 3.40605 18.8742 3.75102 19.0499C4.14319 19.2498 4.65657 19.2498 5.68333 19.2498H16.3167C17.3434 19.2498 17.8569 19.2498 18.249 19.0499C18.5939 18.8742 18.8744 18.5937 19.0502 18.2488C19.25 17.8565 19.25 17.3432 19.25 16.3164V9.68445C19.25 9.15792 19.25 8.89467 19.1822 8.65224C19.122 8.43749 19.0232 8.23551 18.8907 8.05623C18.741 7.85383 18.5332 7.69221 18.1176 7.36898L11.9004 2.53344C11.5784 2.28296 11.4174 2.15772 11.2395 2.10958C11.0827 2.0671 10.9173 2.0671 10.7605 2.10958C10.5826 2.15772 10.4216 2.28296 10.0996 2.53344Z"
      stroke="white"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
